var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6602 7L7.66016 25",
    stroke: "#101010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1602 13C12.0932 13 13.6602 11.433 13.6602 9.5C13.6602 7.567 12.0932 6 10.1602 6C8.22716 6 6.66016 7.567 6.66016 9.5C6.66016 11.433 8.22716 13 10.1602 13Z",
    stroke: "#101010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1602 26C25.0932 26 26.6602 24.433 26.6602 22.5C26.6602 20.567 25.0932 19 23.1602 19C21.2272 19 19.6602 20.567 19.6602 22.5C19.6602 24.433 21.2272 26 23.1602 26Z",
    stroke: "#101010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentBlack);
export default __webpack_public_path__ + "static/media/percent-black.0e1e56798f8fd097ad980aafb033e200.svg";
export { ForwardRef as ReactComponent };